// extracted by mini-css-extract-plugin
module.exports = {"content":"Reports_content__1yhZK"};